import React from 'react';
import {useContextState as useUserContext} from '../../../../../context/user';
import {useContextState as useSubClientContext} from '../../../../../context/sub-client';
import {useSalesmanContext} from '../../../../../context/salesman';
import {useMainProperties} from '../../../../../hooks/app/useMainProperties';

type GoBackType = 'SalesmanClientDashboard' | 'Dashboard';

export const useProofPayment = () => {
  const {uiConfiguration} = useUserContext();
  const {isSalesMan} = useMainProperties();
  const {sendProof: sendSubClientProof} = useSubClientContext();
  const {sendProof: sendSalesmanProof} = useSalesmanContext();
  const [goBackScreen] = React.useState(
    isSalesMan() ? 'SalesmanClientDashboard' : ('Dashboard' as GoBackType),
  );

  return {
    sendSalesmanProof,
    sendSubClientProof,
    uiConfiguration,
    goBackScreen,
  };
};
